import classNames from "classnames";
import { Button } from "~/common/mui";
import type { CMSButtonProps } from "~/features/cms/types/props";
import { getButtonSize, getButtonType } from "~/features/cms/utils/helpers";

export const CMSButton = (props: CMSButtonProps) => {
  const { url, label, className, buttonType, size, openInExternal } = props;

  const buttonProps = {
    ...getButtonSize(size ?? "BIG"),
    ...getButtonType(buttonType ?? "primary"),
  };

  // @ts-ignore
  return (
    <div className="scha__cms">
      <Button
        component={"a"}
        className={classNames("scha__cmssection__sub--button scha__cmssection__button", className)}
        href={url}
        {...buttonProps}
        target={openInExternal ? "_blank" : undefined}
      >
        {label}
      </Button>
    </div>
  );
};
